var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tiptap-vuetify',{staticStyle:{"overflow-y":"auto"},attrs:{"extensions":_vm.extensions,"value":_vm.content,"card-props":{ minHeight: _vm.minHeight }},on:{"input":function (newValue) { return _vm.$emit('update:content', newValue); }}})}
var staticRenderFns = []

export { render, staticRenderFns }